package pl.zar.tikthrow.shared.domain

import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * A saved bookmark linking a post to the moment it was bookmarked.
 *
 * @param id unique identifier of the bookmark.
 * @param postId id of the bookmarked post.
 * @param createdAt moment the bookmark was created.
 */
data class Bookmark(val id: String, val postId: String, val createdAt: Instant)

/** Like state of a post for the current user. */
@Serializable
enum class LikeStatus {
    NOT_LIKED, LIKED;
}

/** Bookmark state of a post for the current user. */
@Serializable
enum class BookmarkStatus {
    NOT_BOOKMARKED, BOOKMARKED;
}

/** Classification of errors surfaced by the social feed. */
@Serializable
enum class FeedErrorType {
    NETWORK_ERROR, SERVER_ERROR, PARSING_ERROR, UNKNOWN;
}

/** Freshness of feed data relative to the last successful refresh. */
@Serializable
enum class StalenessIndicator {
    FRESH, AGING, STALE;
}
